import React from 'react';
import { useNavigate } from 'react-router-dom';

import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import Link from '@mui/material/Link';

type Props = {
  /** ガイドページのパス（guide/以降の部分。例: 'user-management'） */
  to: string;
  /** リンクテキスト */
  children: React.ReactNode;
};

/**
 * ガイドページ間のナビゲーションリンク
 */
const GuideLink: React.FC<Props> = ({ to, children }) => {
  const navigate = useNavigate();
  const path = `/guide/${to}`;

  return (
    <Link
      component="button"
      variant="body2"
      onClick={() => navigate(path)}
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 0.5,
        textDecoration: 'none',
        '&:hover': { textDecoration: 'underline' },
      }}
    >
      {children}
      <OpenInNewIcon sx={{ fontSize: 14 }} />
    </Link>
  );
};

export default GuideLink;
